// @flow

import React from 'react'
import loadingImg from '../popup/loading.gif'
let styles = require('./index.scss')

export default class extends React.PureComponent<*> {
  render () {
    let { padding = 80, loading = true, show = true, text } = this.props
    return (
      <div>
        {show && (
          <div className={styles.mainBox} style={{ padding }}>
            {loading && (
              <div className={styles.spinner}>
                <img src={loadingImg} />
              </div>
            )}
            {text && <div className={styles.tipWord}>{text}</div>}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frame/ui/Spinner/index.js